import { Grid, MenuItem, Typography } from "@mui/material";
import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { getAgentesMaterialEnfermedadProfesional } from "../../../../../redux/actions/denuncia";
import FormikActions from "../../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../../commons/formik/FormikAutocomplete";
import FormikSelect from "../../../../commons/formik/FormikSelect";
import FormikTextField from "../../../../commons/formik/FormikTextField";
import { StyledNuevaDenuncia } from "../../../../styled/Siniestros";
import { enfermedadProfesionalValidation, validateRequiredFields, } from "../validation/formValidation";

const EnfermedadProfesionalForm = ({
  handleSubmit,
  model,
  fields,
  tiposEnfermedadProfesional,
  listaAgenteMaterial,
  listaAgenteCausante,
}) => {
  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={model}
      onSubmit={handleSubmit}
      validationSchema={enfermedadProfesionalValidation}
      validate={(values) => validateRequiredFields(values, fields)}
    >
      {({ values }) => (
        <StyledNuevaDenuncia.FormContainer>
          <StyledNuevaDenuncia.GridContainer container spacing={9}>
            <Grid item xs={6}>
              <FormikSelect
                fullWidth
                name="tipoEnfermedadProfesional"
                label={`Tipo de enfermedad ${fields.subtipoSiniestro?.obligatorio ? "*" : ""
                  }`}
                variant="standard"
                value={tiposEnfermedadProfesional[0].id}
              >
                {tiposEnfermedadProfesional.map(({ id, nombre }) => {
                  return (
                    <MenuItem value={id} key={id}>
                      {nombre}
                    </MenuItem>
                  );
                })}
              </FormikSelect>
            </Grid>
            <Grid item xs={6}>
              <FormikTextField
                fullWidth
                id="tiempoExposicionAgenteCausante"
                name="tiempoExposicionAgenteCausante"
                type="number"
                label={`Tiempo de exposición ${fields.tiempoExposicionAgenteCausante?.obligatorio ? "*" : ""
                  }`}
              />
              <Typography
                style={{ marginLeft: "5px", color: "grey" }}
                variant="caption"
              >
                Expresado en meses
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <FormikAutocomplete
                fullWidth
                name="agenteCausanteEnfermedadProfesional"
                label={`Agente causante ${fields.agenteCausanteEnfermedadProfesional?.obligatorio
                  ? "*"
                  : ""
                  }`}
                variant="standard"
                options={listaAgenteCausante}
                renderOption={(option) => option.nombre}
                filterOptions={(option) => option.nombre}
                callBack={(value) => {
                  if (value) {
                    dispatch(getAgentesMaterialEnfermedadProfesional(value.id));
                  }
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormikAutocomplete
                fullWidth
                name="agenteCausante"
                label={`Agente material ${fields.agenteCausante?.obligatorio ? "*" : ""
                  }`}
                variant="standard"
                options={listaAgenteMaterial}
                disable={!values.agenteCausanteEnfermedadProfesional}
                renderOption={(option) => option.nombre}
                getOptions={() => (
                  dispatch(getAgentesMaterialEnfermedadProfesional(values.agenteCausanteEnfermedadProfesional))
                )}
                filterOptions={(option) => option.nombre}
              />
            </Grid>
          </StyledNuevaDenuncia.GridContainer>
          <StyledNuevaDenuncia.ButtonContainer>
            <FormikActions submit="Siguiente" />
          </StyledNuevaDenuncia.ButtonContainer>
        </StyledNuevaDenuncia.FormContainer>
      )}
    </Formik>
  );
};

export default EnfermedadProfesionalForm;
